module.exports = __webpack_public_path__ + "media/images/v3/s_1-bc9092bfab1c17c833ceb52effe69da0.png";